<template>
  <div class="card-315-wrapper border p-1">
    <div class="position-relative card-315-over-image-wrapper  ">
      <img :src="image" :alt="alt" class="card-315-image">
      <div class="over-image">
        <slot name="p-1">
          <button class="btn btn-primary">button</button>
        </slot>
      </div>
    </div>
    <hr>
    <div class="card-315-description ">
      <slot name="p-2">
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad atque autem beatae culpa dol</p>
      </slot>
    </div>
  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";


export default {
  name: "Card315",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },
}

</script>

<style scoped>
.card-315-wrapper {
  height: 390px;
  background: var(--light);
}

.card-315-wrapper * {
  color: var(--dark);
}


.over-image {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
}

.card-315-image {
  height: 250px;
  width: 100%;
  object-fit: cover;
}
</style>